// ============================================
// src/components/maintenance/MaintenanceStats.js
// Mobile-Optimized Statistics Dashboard
// ============================================

import React from 'react';

function MaintenanceStats({ stats }) {
  const statCards = [
    {
      title: 'Total Tasks',
      value: stats.totalTasks,
      icon: '📋',
      color: '#667eea',
      bgColor: 'rgba(102, 126, 234, 0.1)'
    },
    {
      title: 'Completed',
      value: stats.completedTasks,
      icon: '✅',
      color: '#28a745',
      bgColor: 'rgba(40, 167, 69, 0.1)'
    },
    {
      title: 'Pending',
      value: stats.pendingTasks,
      icon: '⏳',
      color: '#ffc107',
      bgColor: 'rgba(255, 193, 7, 0.1)'
    },
    {
      title: 'Overdue',
      value: stats.overdueTask,
      icon: '⚠️',
      color: '#dc3545',
      bgColor: 'rgba(220, 53, 69, 0.1)'
    },
    {
      title: 'This Week',
      value: stats.upcomingThisWeek,
      icon: '📅',
      color: '#17a2b8',
      bgColor: 'rgba(23, 162, 184, 0.1)'
    },
    {
      title: 'Monthly Spend',
      value: `₹${stats.monthlySpend.toFixed(0)}`,
      icon: '💰',
      color: '#9b59b6',
      bgColor: 'rgba(155, 89, 182, 0.1)'
    }
  ];

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
      gap: '10px',
      marginBottom: '20px'
    }}>
      {statCards.map((stat, index) => (
        <div
          key={index}
          style={{
            background: 'white',
            borderRadius: '10px',
            padding: '15px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            borderLeft: `4px solid ${stat.color}`,
            transition: 'transform 0.2s',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '8px'
          }}>
            <span style={{
              fontSize: '24px',
              background: stat.bgColor,
              padding: '8px',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {stat.icon}
            </span>
          </div>
          <div style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: stat.color,
            marginBottom: '4px'
          }}>
            {stat.value}
          </div>
          <div style={{
            fontSize: '12px',
            color: '#666',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            {stat.title}
          </div>
        </div>
      ))}
    </div>
  );
}

export default MaintenanceStats;